import { useMemo } from 'react'
import { ReservationSeatTypeReference } from '@/types/codegen-federation'
import { ShowtimeReservation } from '../SeatMapView'

export type AvailableSeatType = {
  reference: string
  description: string
  cloudinaryPath: string
}

export const findAvailableSeatType = (seatTypes: AvailableSeatType[], reference: ReservationSeatTypeReference) => {
  return seatTypes.find((seatType) => seatType.reference === reference)
}

export const SELECTED_SEAT = {
  reference: 'SELECTED',
  description: 'Selected',
  cloudinaryPath: '/v1733165174/Tickets/Seat%20Map%20v3/chair-standard-regular-selected',
}

const formatPresentSeatTypes = (
  seatTypesPresent: NonNullable<NonNullable<ShowtimeReservation>['showtimeSeatingInfo']>['seatTypesPresent'],
): AvailableSeatType[] => {
  if (!seatTypesPresent) return []

  return seatTypesPresent
    .map((seatType) => {
      return {
        reference: seatType?.reference,
        description: seatType?.description,
        cloudinaryPath: seatType?.icons?.default?.cloudinaryPath,
      }
    })
    .filter((seatType) => seatType?.cloudinaryPath && seatType?.reference) as AvailableSeatType[]
}

export const useAvailableSeatTypes = (
  seatTypesPresent: NonNullable<NonNullable<ShowtimeReservation>['showtimeSeatingInfo']>['seatTypesPresent'],
): AvailableSeatType[] => {
  return useMemo(() => formatPresentSeatTypes(seatTypesPresent), [seatTypesPresent])
}
